/*
  Suggestions de recherche natives Shopify (remplace l'autocomplete Algolia).
  API : /search/suggest.json (Predictive Search), alimentée par l'index Shopify
  et les réglages de l'app Search & Discovery (synonymes, mises en avant).
*/
(function () {
  var form = document.getElementById('search-form');
  var input = document.getElementById('search-query');
  if (!form || !input || !window.fetch) return;

  var panel = document.createElement('div');
  panel.className = 'predictive-search';
  panel.id = 'predictive-search-results';
  panel.setAttribute('role', 'listbox');
  panel.hidden = true;
  form.appendChild(panel);

  input.setAttribute('autocomplete', 'off');
  input.setAttribute('aria-controls', panel.id);
  input.setAttribute('aria-expanded', 'false');

  var timer = null;
  var controller = null;
  var lastQuery = '';

  function escapeHtml(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(price) {
    var value = parseFloat(price);
    if (isNaN(value)) return '';
    return value.toLocaleString('fr-BE', { style: 'currency', currency: 'EUR' });
  }

  function imageUrl(product) {
    var url = (product.featured_image && product.featured_image.url) || product.image;
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function close() {
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  }

  function open() {
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  // Chaque mot entre guillemets : Shopify cherche alors le mot exact (accents et
  // pluriels compris) sans tolérance aux fautes, sinon « lego » ramène des leggings.
  // Les mots avec des chiffres (références comme BUR39, tailles) restent tels quels :
  // entre guillemets, Shopify ne les trouve plus.
  // La page de recherche relance sans guillemets si rien ne correspond.
  function strictQuery(query) {
    if (/["*:]/.test(query)) return query;
    return query.split(/\s+/).filter(Boolean).map(function (word) {
      return /\d/.test(word) ? word : '"' + word + '"';
    }).join(' ');
  }

  // Référence d'article (SKU : lettres + chiffres, ex. BUR39) : on montre aussi
  // les articles vendus ou épuisés, en fin de liste, pour l'équipe du magasin.
  function isReference(query) {
    return /^[a-z]{2,5}\d+$/i.test(query.trim());
  }

  function searchUrl(query) {
    return '/search?type=product' + (isReference(query) ? '&options%5Bunavailable_products%5D=last' : '') + '&options%5Bprefix%5D=none&options%5Bfields%5D=title,vendor,product_type,tag,variants.title,variants.sku&q=' + encodeURIComponent(strictQuery(query));
  }

  function render(query, results) {
    var products = results.products || [];
    var queries = (results.queries || []).filter(function (q) {
      return q.text.toLowerCase() !== query.toLowerCase();
    });
    var html = '';

    if (queries.length) {
      html += '<ul class="predictive-search-queries">';
      queries.forEach(function (q) {
        html += '<li><a href="' + escapeHtml(searchUrl(q.text)) + '">' + (q.styled_text || escapeHtml(q.text)) + '</a></li>';
      });
      html += '</ul>';
    }

    if (products.length) {
      html += '<ul class="predictive-search-products">';
      products.forEach(function (p) {
        var img = imageUrl(p);
        html += '<li role="option"><a href="' + escapeHtml(p.url) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" width="60" height="60" loading="lazy">' : '<span class="predictive-search-noimg"></span>') +
          '<span class="predictive-search-info">' +
            '<span class="predictive-search-title">' + escapeHtml(p.title) + '</span>' +
            (p.vendor ? '<span class="predictive-search-vendor">' + escapeHtml(p.vendor) + '</span>' : '') +
          '</span>' +
          '<span class="predictive-search-price">' + formatPrice(p.price) + '</span>' +
        '</a></li>';
      });
      html += '</ul>';
      html += '<a class="predictive-search-all" href="' + escapeHtml(searchUrl(query)) + '">Voir tous les résultats pour « ' + escapeHtml(query) + ' »</a>';
    } else {
      html += '<p class="predictive-search-empty">Aucun article en dépôt pour « ' + escapeHtml(query) + ' ».</p>';
    }

    panel.innerHTML = html;
    open();
  }

  function fetchSuggestions(query) {
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,query' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=' + (isReference(query) ? 'last' : 'hide') +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (query !== lastQuery) return;
        render(query, (data.resources && data.resources.results) || {});
      })
      .catch(function () { /* requête annulée ou réseau : on garde l'affichage */ });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    lastQuery = query;
    clearTimeout(timer);
    if (query.length < 2) {
      close();
      return;
    }
    timer = setTimeout(function () { fetchSuggestions(query); }, 200);
  });

  form.addEventListener('submit', function () {
    var query = input.value.trim();
    var unavailable = form.querySelector('input[name="options[unavailable_products]"]');
    if (isReference(query)) {
      if (!unavailable) {
        unavailable = document.createElement('input');
        unavailable.type = 'hidden';
        unavailable.name = 'options[unavailable_products]';
        form.appendChild(unavailable);
      }
      unavailable.value = 'last';
    } else if (unavailable) {
      unavailable.parentNode.removeChild(unavailable);
    }
    input.value = strictQuery(query);
  });

  input.addEventListener('focus', function () {
    if (panel.innerHTML && input.value.trim().length >= 2) open();
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  document.addEventListener('click', function (event) {
    if (!form.contains(event.target)) close();
  });
})();
